import React, { memo, useEffect, useState, useRef } from "react";
import styles from "./styles.module.css";
import Loader2 from "../Loader/index2";
import { ExitIcon } from "../SvgIcons";
import RatingField from "../RatingField";

const ProductReviews = ({
  product = null,
  product_details,
  variantId,
  v3 = false,
}) => {
  // console.log(product_details,"productdetailssss--->");
  
  const initialFormData = {
    display_name: "",
    email: "",
    review_content: "",
    review_title: "",
    review_score: 0,
    sku: product_details?.sku||"",
    product_title: product_details?.product_title||"",
    product_url: product_details?.product_url||"",
    appkey: "ahHyITcI0fkzYo7KejQeWGiBK2CXMKvLvTZ8KUBJ",
    domain: "https://brunomd.com",
  };
// console.log(product_details,"details---->");

  const initialFormData2 = {
    display_name: "",
    email: "",
    review_content: "",
    sku: product_details?.sku,
    product_title: product_details?.product_title,
    product_url: product_details?.product_url,
    appkey: "ahHyITcI0fkzYo7KejQeWGiBK2CXMKvLvTZ8KUBJ",
  };
  const [formData, setFormData] = useState(initialFormData);

  const [formData2, setFormData2] = useState(initialFormData2);
  const [displayName, setDisplayName] = useState();
  const [displayName2, setDisplayName2] = useState();
  const [errors, setErrors] = useState({});
  const [errors2, setErrors2] = useState({});
  const [modal, setModal] = React.useState(false);
  const [modal1, setModal1] = React.useState(false);
  const [modal2, setModal2] = React.useState(false);
  const [modal3, setModal3] = React.useState(false);
  const handleRatingChange = (value) => {
    setFormData({ ...formData, review_score: value });
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (e.target.name == "display_name") {
      setDisplayName(e.target.value);
    }
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleChange2 = (e) => {
    setFormData2({ ...formData2, [e.target.name]: e.target.value });
    if (e.target.name == "display_name") {
      setDisplayName2(e.target.value);
    }
    setErrors2({ ...errors2, [e.target.name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm(formData);
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    try {
      const response = await fetch("https://api.yotpo.com/v1/widget/reviews", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        console.log("response", response);
        setModal1(true);
        setModal(false);
        setFormData(initialFormData);
      } else {
        console.error("Failed to post data");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleQuestionSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm2(formData2);
    if (Object.keys(formErrors).length > 0) {
      setErrors2(formErrors);
      return;
    }

    try {
      const response = await fetch(
        "https://api.yotpo.com/questions/send_confirmation_mail",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData2),
        }
      );

      if (response.ok) {
        console.log("response", response);
        setModal3(true);
        setModal2(false);
        setFormData2(initialFormData2);
      } else {
        console.error("Failed to post data");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleClick = () => {
    setModal(true);
    setFormData(initialFormData);
    setErrors({});
  };

  const handleClick2 = () => {
    setModal2(true);
    setFormData2(initialFormData2);
    setErrors2({});
  };

  const handleClose = () => {
    setModal1(false);
    setModal(false);
    setFormData(initialFormData);
  };

  const handleClose2 = () => {
    setModal3(false);
    setModal2(false);
    setFormData2(initialFormData2);
  };

  const validateForm = (data) => {
    const errors = {};
    const maxlength = 100;
    const maxlengthShort = 100;
    const regx = /^[a-zA-Z0-9 .?,']+$/;
    if (!data.review_title.trim()) {
      errors.review_title = "Review's title can't be empty";
    } else {
      if (data.review_title.length > maxlengthShort) {
        errors.review_title = "Please enter only 100 characters.";
      }
      if (!regx.test(data.review_title)) {
        errors.review_title = "Please enter letters only.";
      }
    }
    if (!data.review_content.trim()) {
      errors.review_content = "Review's body can't be empty";
    } else {
      if (data.review_content.length > maxlength) {
        errors.review_content = "Please enter only 2000 characters.";
      }
      // if (!regx.test(data.review_content)) {
      //   errors.review_content = "sono ammesse solo lettere";
      // }
      // ttttttttttt
    }
    if (!data.display_name.trim()) {
      errors.display_name = "Name can't be empty";
    } else {
      if (data.display_name.length > maxlengthShort) {
        errors.display_name = "Please enter only 100 characters.";
      }
      if (!regx.test(data.display_name)) {
        errors.display_name = "Please enter letters only.";
      }
    }
    if (!data.email.trim()) {
      errors.email = "Email is required";
    } else if (!isValidEmail(data.email)) {
      errors.email = "invalid email format";
    }
    return errors;
  };

  const validateForm2 = (data) => {
    const errors = {};
    const maxlength = 100;
    const maxlengthShort = 100;
    const regx = /^[a-zA-Z0-9 .?,']+$/;
    if (!data.review_content.trim()) {
      errors.review_content = "Question can't be empty";
    } else {
      if (data.review_content.length > maxlength) {
        errors.review_content = "Please enter only 2000 characters.";
      }
    }
    if (!data.display_name.trim()) {
      errors.display_name = "Name can't be empty";
    } else {
      if (data.display_name.length > maxlengthShort) {
        errors.display_name = "Please enter only 100 characters.";
      }
      if (!regx.test(data.display_name)) {
        errors.display_name = "Please enter letters only.";
      }
    }
    if (!data.email.trim()) {
      errors.email = "Email can't be empty";
    } else if (!isValidEmail(data.email)) {
      errors.email = "invalid email format";
    }
    return errors;
  };

  const isValidEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  if (modal || modal1 || modal2 || modal3) {
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
    document.documentElement.style.overflow = "auto";
  }

  const [productId, setProductId] = useState(
    product
      ? product?.variants?.edges?.length
        ? product?.variants?.edges[0].node.id.split("ProductVariant/").length ==
          2
          ? product?.variants?.edges[0].node.id.split("ProductVariant/")[1]
          : undefined
        : undefined
      : variantId
  );
  useEffect(() => {
    if (v3) {
      (function e() {
        var e = document.createElement("script");
        (e.type = "text/javascript"),
          (e.async = true),
          (e.defer = true),
          (e.src = `https://cdn-widgetsrepository.yotpo.com/v1/loader/ahHyITcI0fkzYo7KejQeWGiBK2CXMKvLvTZ8KUBJ`);
        var t = document.getElementsByTagName("script")[0];
        t.parentNode.insertBefore(e, t);
      })();
    } else {
      (function e() {
        var e = document.createElement("script");
        (e.type = "text/javascript"),
          (e.async = true),
          (e.defer = true),
          (e.src = `//staticw2.yotpo.com/ahHyITcI0fkzYo7KejQeWGiBK2CXMKvLvTZ8KUBJ/widget.js`);
        var t = document.getElementsByTagName("script")[0];
        t.parentNode.insertBefore(e, t);
      })();
    }
  }, [productId]);

  if (v3) {
    return (
      <div
        class="yotpo-widget-instance"
        data-yotpo-instance-id="520292"
        data-yotpo-product-id={productId}
      ></div>
    );
  } else {
    return (
      <section id="review_ingredients" className={styles.ingredientsHolder}>
        <div
          className={`${styles.reviewContainerV2} ${styles.v2}  ${styles.BtnAlign}`}
        >
          <div className={styles.straightLine1}>
            <h3 className={styles.reviewHeader}>Verified Customer Reviews</h3>
          </div>
          <div className={styles.straightLine2}>
            <button onClick={() => handleClick()} className={styles.reviewbtn}>
              Write A Review
            </button>
            <button onClick={() => handleClick2()} className={styles.reviewbtn}>
              Ask A Question
            </button>
          </div>
        </div>
        <div className={styles.wrapper}>
          {productId && (
            <div class="yotpo yotpo-main-widget" data-product-id={productId}>
              <Loader2 />
            </div>
          )}
        </div>
        {modal === true && (
          <div className={styles.modal}>
            <div className={styles.modalOverlayV2}></div>
            <div className={styles.modalContainer1}>
              <button
                onClick={() => setModal(false)}
                className={styles.exitButton1}
                style={{ border: `1px solid black` }}
              >
                <ExitIcon />
              </button>
              <div className={styles.modalCardContainerV2}>
                <h1 className={styles.title} style={{ color: "" }}>
                  Write A Review
                </h1>
                <form onSubmit={handleSubmit} enctype="multipart/form-data">
                  <div className={styles.OverflowDiv}>
                    <div className={styles.ratingSection}>
                      {/* <p>
                        Valuta la tua esperienza{" "}
                        <span className={styles.spanRed}>*</span>
                      </p> */}

                      <RatingField
                        className={styles.goldenStar}
                        value={formData.review_score}
                        onChange={handleRatingChange}
                      />
                    </div>

                    <div className={styles.inputField}>
                      <label>
                        Review <span className={styles.spanRed}>*</span>
                      </label>
                      <br></br>
                      <textarea
                        type="text"
                        rows="5"
                        cols="72"
                        name="review_content"
                        value={formData.review_content}
                        onChange={handleChange}
                      />
                      {errors.review_content && (
                        <span className={styles.error}>
                          {errors.review_content}
                        </span>
                      )}
                    </div>

                    <div className={styles.inputFieldMain11}>
                      <label>
                        Title <span className={styles.spanRed}>*</span>
                      </label>
                      <br></br>
                      <input
                        type="text"
                        name="review_title"
                        value={formData.review_title}
                        onChange={handleChange}
                      />
                      {errors.review_title && (
                        <span className={styles.error}>
                          {errors.review_title}
                        </span>
                      )}
                    </div>

                    <div className={styles.inputFieldMain}>
                      <div className={styles.inputField1}>
                        <label>
                          Use your name{" "}
                          <span className={styles.spanRed}>*</span>
                        </label>
                        <br></br>
                        <input
                          type="text"
                          name="display_name"
                          value={formData.display_name}
                          onChange={handleChange}
                        />
                        {errors.display_name && (
                          <span className={styles.error}>
                            {errors.display_name}
                          </span>
                        )}
                      </div>

                      <div className={styles.inputField2}>
                        <label>
                          Email <span className={styles.spanRed}>*</span>
                        </label>
                        <br></br>
                        <input
                          type="text"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        <br></br>
                        {errors.email && (
                          <span className={styles.error}>{errors.email}</span>
                        )}
                      </div>
                    </div>

                    {/* <div className={styles.filesUpload}>
                    <h4>Aggiungi file multimediali</h4>
                    <label onClick={handleFileClick}>
                      <svg
                        data-v-7e5c0c2e=""
                        width="15"
                        height="15"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.75 10.0837H11.25V11.2503H0.75V10.0837ZM6.58333 2.39999V8.91699H5.41667V2.39999L1.87525 5.94199L1.05042 5.11716L6 0.166992L10.9496 5.11658L10.1247 5.94141L6.58333 2.40116V2.39999Z"
                          fill="#2C2C2C"
                        ></path>
                      </svg>
                      Carica
                    </label>
                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleImageChange}
                    />
                    <p>
                      Carica fino a 5 immagini (dimensione massima del file: 2
                      GB)
                    </p>
                    {errors.review_file && (
                      <span className={styles.error}>{errors.review_file}</span>
                    )}
                  </div> */}

                    {/* checkbox */}
                  </div>
                  <div className={styles.flexPare}>
                    <p>
                      <span className={styles.spanRed}>*</span>Indicates a
                      required field
                    </p>
                    <button>POST</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {modal1 === true && (
          <div className={styles.modal}>
            <div className={styles.modalOverlayV2}></div>
            <div className={styles.modalContainer1}>
              <button
                onClick={() => handleClose()}
                className={styles.exitButton1}
                style={{ border: `1px solid black` }}
              >
                <ExitIcon />
              </button>
              <div className={styles.modalCardContainerV2}>
                <div className={styles.OverflowDiv11}>
                  <h5>Thank you, {displayName}</h5>
                  <p>
                    Your feedback will help other buyers to take better
                    decisions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {modal2 === true && (
          <div className={styles.modal}>
            <div className={styles.modalOverlayV2}></div>
            <div className={styles.modalContainer1}>
              <button
                onClick={() => setModal2(false)}
                className={styles.exitButton1}
                style={{ border: `1px solid black` }}
              >
                <ExitIcon />
              </button>
              <div className={styles.modalCardContainerV2}>
                <h1 className={styles.title} style={{ color: "" }}>
                  Ask A Question
                </h1>
                <form onSubmit={handleQuestionSubmit}>
                  <div className={styles.OverflowDiv}>
                    <div className={styles.inputField}>
                      <label>
                        Question <span className={styles.spanRed}>*</span>
                      </label>
                      <br></br>
                      <textarea
                        type="text"
                        rows="3"
                        cols="72"
                        name="review_content"
                        value={formData2.review_content}
                        onChange={handleChange2}
                      />
                      {errors2.review_content && (
                        <span className={styles.error}>
                          {errors2.review_content}
                        </span>
                      )}
                    </div>

                    <div className={styles.inputFieldMain}>
                      <div className={styles.inputField1}>
                        <label>
                          Use your name{" "}
                          <span className={styles.spanRed}>*</span>
                        </label>
                        <br></br>
                        <input
                          type="text"
                          name="display_name"
                          value={formData2.display_name}
                          onChange={handleChange2}
                        />
                        {errors2.display_name && (
                          <span className={styles.error}>
                            {errors2.display_name}
                          </span>
                        )}
                      </div>

                      <div className={styles.inputField2}>
                        <label>
                          Email <span className={styles.spanRed}>*</span>
                        </label>
                        <br></br>
                        <input
                          type="text"
                          name="email"
                          value={formData2.email}
                          onChange={handleChange2}
                        />
                        <br></br>
                        {errors2.email && (
                          <span className={styles.error}>{errors2.email}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className={styles.flexPare}>
                    <p>
                      <span className={styles.spanRed}>*</span>Indicates a
                      required field
                    </p>
                    <button>POST</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {modal3 === true && (
          <div className={styles.modal}>
            <div className={styles.modalOverlayV2}></div>
            <div className={styles.modalContainer1}>
              <button
                onClick={() => handleClose2()}
                className={styles.exitButton1}
                style={{ border: `1px solid black` }}
              >
                <ExitIcon />
              </button>
              <div className={styles.modalCardContainerV2}>
                <div className={styles.OverflowDiv11}>
                  <h5>Thank you, {displayName2}</h5>
                  <p>We will answer as soon as possible.</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    );
  }
};

export default memo(ProductReviews);
